// extracted by mini-css-extract-plugin
export default {"aboutContainer":"AboutPage_aboutContainer__gf++K"};